import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mouser: [],
  digikey: [],
  element14: [],
  tme: [],
  rutronik: [],
  ti: [],
  arrow: [],
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setDistributorData: (state, action) => {
      state[action.payload.name] = action.payload.data;
    },
    resetDistributorData: (state, action) => {
      state[action.payload.name] = [];
    },
    clearDistributorData: (state) => {
      state = initialState;
    },
  },
});

export const { setDistributorData, clearDistributorData, resetDistributorData } =
  searchSlice.actions;
export default searchSlice.reducer;
